var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOk = function SvgOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30ZM23.374 12.3797C23.9519 11.744 23.9051 10.7602 23.2694 10.1823C22.6337 9.60442 21.6499 9.65126 21.072 10.287L14.2964 17.74L10.7744 14.805C10.1144 14.255 9.13351 14.3442 8.58353 15.0042C8.03354 15.6641 8.12271 16.645 8.78269 17.195L13.4494 21.0839C14.0893 21.6172 15.0358 21.5517 15.5962 20.9353L23.374 12.3797Z",
    fill: "currentColor"
  })));
};
export default SvgOk;